export const CS_INFO_CONST = {
  display: '0812-9532-2050',
  value: '081295322050',
  telHref: 'tel:081295322050',
  firstEmail: 'account.executive@birdmobil.id',
  secondEmail: 'marketing.pmm@bluebirdgroup.com',
  whatsapp: 'https://wa.me/6281295322050',
  csEmail: 'customerservice@birdmobil.id'
}
